import axios from 'axios'

//export const baseUrl = "http://renaserver.ddns.net/api/";
export const baseUrl = window.API;

export default() => {

  if (localStorage.rogg_token){
    axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.rogg_token;
  }


  return axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    timeout:30000,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'app-client':'easa'
    }
  });

}



// WEBPACK FOOTER //
// ./src/Api/index.js